import slideStyle from "./InfoPage.module.scss";
import ContactAppendix from "./ContactAppendix";
import Heading from "./Heading";
import { getMessage, Message, MessageContext } from "@messageformat/react";
import { useContext } from "react";

const KioskAI = () => {
  const messageContext = useContext(MessageContext);

  return (
    <>
      <Heading
        subtitle={<Message id="infoPages.kds.subtitle" />}
        title={<Message id="infoPages.kds.title" />}
        hints={[
          <Message id="infoPages.kds.hints.hint1" />,
          <Message id="infoPages.kds.hints.hint2" />,
        ]}
      />

      <div className={slideStyle.section}>
        <div
          dangerouslySetInnerHTML={{
            __html: getMessage(messageContext, "infoPages.kds.description")(),
          }}
        />

        <div
          className={slideStyle.heading}
          style={{ marginTop: "20px", marginBottom: "20px" }}
        >
          <h1
            dangerouslySetInnerHTML={{
              __html: getMessage(messageContext, "infoPages.kds.summary")(),
            }}
          />
        </div>

        <ContactAppendix />
      </div>
    </>
  );
};

export default KioskAI;
